import React, { useEffect, useState } from "react";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../../Utils/constants";
import { RxCross2 } from "react-icons/rx";
const BookPositionSky = ({ object, setFancyModal }) => {
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  const [data, setData] = useState([]);
  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookPosition +
        `?eventId=${object?.eventId}&type=${
          obj[object?.categoryType]
        }&selectionId=${object?.selectionId}&marketId=${object?.marketId}`
    );

  
      if (response_users.success) {
        setData(response_users?.results);
      }
  
  };
  useEffect(() => {
    if (object?.prevPosition) {
      getFancyBetPosition();
    }
  }, [object]);

  return (
    <div
      id="fancyBetBookLeftSide"
      className="overlay"
      style={{ display: "flex" }}
    >
      <div id="sideWrap" className="side-wrap full-pop">
        <div className="side-head">
          <h3 className>Book Position</h3>
          <div
            onClick={() =>
              setFancyModal({
                status: false,
                object: {},
              })
            }
            className="close"
          >
            Close
          </div>
        </div>
        <div id="sideContent" className="side-content">
          <div className="path-wrap">
            <ul>
              <li id="headerName"> {object?.fancyName}</li>
            </ul>
          </div>
          <table id="table" className="table table-fancy">
            <tbody>
              <tr>
                <th width="40%">Runs</th>
                <th width="60%">Amount</th>
              </tr>
              <tr id="trTemp">
                <td id="runs" className>
                  <strong />
                </td>
                <td id="exposure" className>
                  <strong />
                </td>
              </tr>
              {data?.bets?.length > 0 &&
                data?.bets?.map((res) => {
                  return (
                    <tr id="runsEx" style={{ display: "table-row" }}>
                      <td
                        id="runs"
                        className={`col-${res?.position >= 0 ? "back" : "lay"}`}
                      >
                        <strong>{res.betRun}</strong>
                      </td>
                      <td
                        id="exposure"
                        className={`col-${res?.position >= 0 ? "back" : "lay"}`}
                      >
                        <strong
                          style={{ color: res?.position >= 0 ? "" : "red" }}
                        >
                          {" "}
                          {res?.position >= 0
                            ? `${toFixedWithoutRounding(res?.position)}`
                            : `(${Math.abs(
                                toFixedWithoutRounding(res?.position)
                              )})`}
                        </strong>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BookPositionSky;
